<template>
  <nav class="navbar navbar--light">
    <div class="navbar__start">
      
      <a class="navbar__item u-hidden-up@lg" @click="toggleSider">
        <i class="i-menu i-menu--light"></i>
      </a>
      <!--
      <a href="http://cover.20theme.com" class="navbar__item u-hidden-down@sm" target="_blank">Home</a>
      <router-link to="/getting-started" class="navbar__item u-hidden-down@sm">Documentation</router-link>
      <c-dropdown>
        <a class="navbar__item has-children u-hidden-down@sm">Resources</a>
        <c-dropmenu slot="content">
          <c-dropmenu-item title="Point" href="http://point.moyu.io" target="_blank" />
          <c-dropmenu-item title="Flatpickr" href="https://flatpickr.js.org/" target="_blank" />
          <c-dropmenu-item title="Chart.js" href="http://www.chartjs.org/" target="_blank" />
          <c-dropmenu-item title="Quill" href="https://quilljs.com/" target="_blank" />
          <c-dropmenu-item title="vue-multiselect" href="https://github.com/shentao/vue-multiselect" target="_blank" />
          <c-dropmenu-item title="vee-validate" href="https://github.com/baianat/vee-validate" target="_blank" />
        </c-dropmenu>
      </c-dropdown>
      <a href="https://themeforest.net/item/cover-dashboard-ui-kit-for-modern-web-application/19869018" class="navbar__item u-hidden-down@sm" target="_blank">Buy It Now</a>
      -->
    </div>
    <div class="navbar__end">
      <!--<div class="navbar__item" v-text="`v${version}`"></div>
      <div class="navbar__item u-hidden-down@sm">
        <c-form-input icon-start="icon-search" placeholder="Search..." flat />
      </div>-->
      <c-dropdown placement="bottom-end" ref="trmenu">
        <div class="navbar__item">
          <a role="button" class="account">
            <figure class="account__media">
              <img class="avatar" :src="'images/avatar.jpg'" alt="">
            </figure>
            <div class="account__after">
              <i class="i-caret i-caret--light"></i>
            </div>
          </a>
        </div>
        <c-dropmenu slot="content">

          <!--<li class="dropmenu__item">
            <router-link to="/secure/profile/edit/" @click.native="$refs.trmenu.hide()">
              <div class="dropmenu__link">
                <span class="dropmenu__icon"><i class="icon-user"></i></span> 
                <div class="dropmenu__text">Profile</div>
              </div>
            </router-link>
          </li>

          <c-dropmenu-divider />-->
          <c-dropmenu-item v-on:click="logout" title="Logout" icon="icon-exit" />
        </c-dropmenu>
      </c-dropdown>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      version: '1.00'
    };
  },
  methods: {
    toggleSider() {
      this.$root.siderOpen = !this.$root.siderOpen;
    },
    logout() {
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/auth/login');
      });
    }
  }
};
</script>
